package model

import org.w3c.dom.parsing.XMLSerializer
import org.w3c.xhr.XMLHttpRequest
import utils.*
import utils.ff.Companion.gsAdmRet
import utils.ff.Companion.println0
import kotlin.js.Json
import kotlin.js.json


//import utils.ff.Companion.ffVss

class Empresa {

    var ID_EMPRESA = 0
    var EMP_NOME = ""
    var EMP_CLIENTE = 0
    var EMP_CNPJ = ""
    var EMP_BANVERSAO = ""
    var EMP_NRSERIE = ""
    var EMP_FTP = ""
    var EMP_WEBVERSAO = ""
    var EMP_CIDADE = ""
    var EMP_CONFQTNOTAOK = ""
    var EMP_SERVERFTP = ""
    var EMP_ENTRFRACIONADA = ""
    var EMP_COLDIGPROD = ""
    var EMP_CONFCEGAS = ""

    var DTATUALIZADO = ""
    var OO_ADMRET = ""

    var EMP_URLPRO00 = ""

    fun construtorLista(_it: String): List<Empresa> {

        var iLinha = 0
        val lObj = ArrayList<Empresa>()

        val it = if (_it.ffCopy(1,1).equals("[")) _it else "[$_it]"

        println0("zuza5555")
        if ((!it.equals(null)) && (!it.equals(""))) {

            val lista = JSON.parse<Array<dynamic>>(it)
            //println0(lista)
            //val lista: ArrayList<Empresa> = JSON.parse<Array<Empresa>>(_it.responseText) antes dessa forma já funcionava
            //val lista1: ArrayList<Empresa> = lista.toMutableList() as ArrayList<Empresa>

            //for (obj in lista) {
            lista.forEach {

                val o = Empresa()
                o.ID_EMPRESA   =  it.ID_EMPRESA.toString().ffVsi()
                o.EMP_NOME = it.EMP_NOME.toString().replace("$"," ").replace("*"," ")
                o.EMP_CLIENTE = it.EMP_CLIENTE.toString().ffVsi()
                o.EMP_NRSERIE = it.EMP_NRSERIE.toString()
                o.EMP_FTP = it.EMP_FTP.toString()
                o.EMP_BANVERSAO = it.EMP_BANVERSAO.toString()
                o.EMP_WEBVERSAO = it.EMP_WEBVERSAO.toString()
                o.EMP_SERVERFTP = it.EMP_SERVERFTP.toString()
                o.EMP_URLPRO00 = it.EMP_URLPRO00.toString().ffVss()
                o.EMP_CIDADE = it.EMP_CIDADE.toString()
                o.EMP_CONFQTNOTAOK = it.EMP_CONFQTNOTAOK.toString()
                o.EMP_NRSERIE = it.EMP_NRSERIE.toString()
                o.EMP_ENTRFRACIONADA = it.EMP_ENTRFRACIONADA.toString()
                o.EMP_COLDIGPROD = it.EMP_COLDIGPROD.toString()
                o.EMP_CONFCEGAS = it.EMP_CONFCEGAS.toString()

                lObj.add(o)
            }

        }
        //println("aqui lObj")
        //println(lObj)
        return lObj
    }

    fun atualizaEmpresa() {

        Service().postGen(ff.goEMPRESA.asDynamic(), "${ff.gsDom1}/empresa/012/" + ff.goEMPRESA.ID_EMPRESA) { objReturn ->
                if (objReturn.PAD_CODIGO.compareTo(200) == 0) {
                println0("Sucesso")
            } else {
                println0("Falha no update")
            }
        }
    }


    /*
    fun ini(ID_EMPRESA: String, EMP_NOME: String, EMP_NRSERIE: String, EMP_FTP: String,
            EMP_WEBVERSAO: String, EMP_CIDADE: String): Empresa {
        this.ID_EMPRESA = ID_EMPRESA.ffVsi()
        this.EMP_NOME = EMP_NOME.ffVss()
        this.EMP_NRSERIE = EMP_NRSERIE.ffVss()
        this.EMP_FTP = EMP_FTP.ffVss().trim()
        this.EMP_WEBVERSAO = EMP_WEBVERSAO.ffVss().trim()
        this.EMP_CIDADE = EMP_CIDADE.ffVss().trim()
        this.EMP_CONFQTNOTAOK = EMP_CONFQTNOTAOK.ffVss().trim()
        return this
    }
     */

/*
    fun construtorLista(it: XMLHttpRequest): List<Empresa> {

        var iLinha = 0
        val lObj = ArrayList<Empresa>()
        //ff.println0("zuza aqui")
        //ff.println0(it.responseText.toString())

        if ((!it.responseText.equals(null)) && (!it.responseText.equals(""))) {
            var sTeste = it.responseText
            if (sTeste.ffCopy(1,1).equals("{"))
                sTeste = "[$sTeste]"

            ff.println0("zuza aqui")
            ff.println0(sTeste)
            val lista = JSON.parse<Array<Empresa>>(sTeste)
            lista.forEach {
                val o = Empresa()
                o.ID_EMPRESA = it.ID_EMPRESA.ffVii()
                o.EMP_NOME = it.EMP_NOME.ffVss()
                o.EMP_NRSERIE = it.EMP_NRSERIE.ffVss()
                o.EMP_FTP = it.EMP_FTP.ffVss()
                o.EMP_WEBVERSAO = it.EMP_WEBVERSAO.ffVss()
                o.EMP_CIDADE = it.EMP_CIDADE.ffVss()
                //o.EMP_CONFQTNOTAOK = it.EMP_CONFQTNOTAOK.ffVss()
                lObj.add(o)


                //arrumar isso CONFQTNOTAOK
            }
        }
        return lObj
    }

 */
//class EmpresaDAO {


    /*
    fun construtorLista(_it: XMLHttpRequest): List<Empresa> {

        var iLinha = 0
        val lObj = ArrayList<Empresa>()

        println0("zuza5555")
        if ((!_it.responseText.equals(null)) && (!_it.responseText.equals(""))) {

            val lista = JSON.parse<Array<dynamic>>(_it.responseText)
            println0(lista)
            //val lista: ArrayList<Empresa> = JSON.parse<Array<Empresa>>(_it.responseText) antes dessa forma já funcionava
            //val lista1: ArrayList<Empresa> = lista.toMutableList() as ArrayList<Empresa>

            //for (obj in lista) {
            lista.forEach {

                val o = Empresa()
                o.ID_EMPRESA   =  it.ID_EMPRESA.toString().ffVsi()
                o.EMP_NOME = it.EMP_NOME.toString()
                o.EMP_NRSERIE = it.EMP_NRSERIE.toString()
                o.EMP_FTP = it.EMP_FTP.toString()
                o.EMP_BANVERSAO = it.EMP_BANVERSAO.toString()
                o.EMP_WEBVERSAO = it.EMP_WEBVERSAO.toString()
                o.EMP_SERVERFTP = it.EMP_SERVERFTP.toString()
                o.EMP_URLPRO00 = it.EMP_URLPRO.toString()
                o.EMP_CIDADE = it.EMP_CIDADE.toString()
                o.EMP_CONFQTNOTAOK = it.EMP_CONFQTNOTAOK.toString()
                o.EMP_NRSERIE = it.EMP_NRSERIE.toString()
                lObj.add(o)
            }

        }
        //println("aqui lObj")
        //println(lObj)
        return lObj
    }

     */

/*
    fun construtorLista(it: XMLHttpRequest): List<Inotas.InotasResu> {

        var iLinha = 0
        val lObj = ArrayList<Inotas.InotasResu>()
        ff.println0("zuza aqui")
        ff.println0(it.responseText.toString())

        if ((!it.responseText.equals(null)) && (!it.responseText.equals(""))) {
            val lista = JSON.parse<Array<Inotas.InotasResu>>(it.responseText)
            lista.forEach {
                val o = Inotas.InotasResu()
                o.INOT_EMPRESA = it.INOT_EMPRESA.ffVii()
                o.INOT_OF = it.INOT_OF.ffVii()
                o.INOT_ORDEM = it.INOT_ORDEM.ffVii()
                o.INOT_ITEORDEM = it.INOT_ITEORDEM.ffVii()
                o.INOT_PROD = it.INOT_PROD.ffVii()
                o.INOT_DESCPROD = it.INOT_DESCPROD.ffVss()
                o.INOT_GRADE = it.INOT_GRADE.ffVii()
                o.INOT_NRPED = it.INOT_NRPED.ffVss()
                o.INOT_QTD = it.INOT_QTD.ffVdo()
                o.INOT_QTDCONT = it.INOT_QTDCONT.ffVdo()
                o.INOT_VLUNIT = it.INOT_VLUNIT.ffVdo()
                o.INOT_TOTAL = it.INOT_TOTAL.ffVdo()
                o.INOT_IVA = it.INOT_IVA.ffVdo()
                o.INOT_GTIN = it.INOT_GTIN.ffVss()
                o.INOT_GTINEMB = it.INOT_GTINEMB.ffVss()
                o.INOT_NCM = it.INOT_NCM.ffVss()
                o.INOT_DTEMI = it.INOT_DTEMI.ffDdd()
                o.INOT_DTVIG = it.INOT_DTVIG.ffDdd()
                o.INOT_LOTEXML = it.INOT_LOTEXML.ffVss()
                o.INOT_PROLOTID = it.INOT_PROLOTID.ffVii()
                o.INOT_FATORFISICO = it.INOT_FATORFISICO.ffVii()
                o.INOT_FATORFISCAL = it.INOT_FATORFISCAL.ffVii()
                o.INOT_ESTCONTROLE = it.INOT_ESTCONTROLE.ffVii()

                o.INOT_OBS00 = it.INOT_OBS00.ffVss()
                o.NOT_CHAVEACESSO00 = it.NOT_CHAVEACESSO00.ffVss()
                o.NOT_NOTATIPO00 = it.NOT_NOTATIPO00.ffVss()
                o.NOT_CLIENTE00 = it.NOT_CLIENTE00.ffVii()
                o.CLI_NOME00 = it.CLI_NOME00.ffVss()
                o.TPNT_DESCR00 = it.TPNT_DESCR00.ffVss()
                o.PROLOT_LOTEFAB00 = it.PROLOT_LOTEFAB00.ffVss()
                o.PROLOT_DTVAL00 = it.PROLOT_DTVAL00.ffDdd()

                o.PRO_MEDIDA = it.PRO_MEDIDA.ffVss()
                o.PRO_UNIDMED = it.PRO_UNIDMED.ffVss()
                o.PRO_QTEMB = it.PRO_QTEMB.ffVdo()
                o.PRO_CXEMBARQUE = it.PRO_CXEMBARQUE.ffVdo()
                o.PRO_UNID = it.PRO_UNID.ffVss()
                o.PRO_PALETQTD = it.PRO_PALETQTD.ffVii()
                o.PRO_PESOLIQ = it.PRO_PESOLIQ.ffVdo()
                o.PRO_PESOBRUTO = it.PRO_PESOBRUTO.ffVdo()
                o.PRO_REFER = it.PRO_REFER.ffVss()
                o.PRO_FABR = it.PRO_FABR.ffVii()
                o.FABR_DESCR = it.FABR_DESCR.ffVss()
                o.PRO_ARM = it.PRO_ARM.ffVss()
                o.ARM_DESCR = it.ARM_DESCR.ffVss()
                o.PRO_DESCRCOMPLETA = it.PRO_DESCRCOMPLETA.ffVss()
                o.EST_BARRAOFICIAL = it.EST_BARRAOFICIAL.ffVss()
                o.ESTG_EAN = it.ESTG_EAN.ffVss()
                o.ESTG_TIPO = it.ESTG_TIPO.ffVss()
                o.ESTG_UNIDVENDA = it.ESTG_UNIDVENDA.ffVdo()
                o.ESTG_EANC = it.ESTG_EANC.ffVss()
                o.ESTG_EAND = it.ESTG_EAND.ffVss()
                o.ESTG_EANU = it.ESTG_EANU.ffVss()
                o.EST_CONTRLOTE = it.EST_CONTRLOTE.ffVss()
                o.EST_DIASVALID = it.EST_DIASVALID.ffVii()
                o.EST_DIASVALIDMIN = it.EST_DIASVALIDMIN.ffVii()
                o.EST_LOCAL00 = it.EST_LOCAL00.ffVss()

                lObj.add(o)
            }
        }
        return lObj
    }

 */

}


